import { render, staticRenderFns } from "./businessCard.vue?vue&type=template&id=72f3f844&scoped=true&"
import script from "./businessCard.vue?vue&type=script&lang=js&"
export * from "./businessCard.vue?vue&type=script&lang=js&"
import style0 from "./businessCard.vue?vue&type=style&index=0&id=72f3f844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3f844",
  null
  
)

export default component.exports